export default "__VITE_ASSET__BnOYd8ou__"